const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M5.42 6.03H4c-1.1 0-2-.9-2-2s.9-2 2-2h10v1h2v-1h1c.55 0 1-.45 1-1s-.45-1-1-1H4c-2.21 0-4 1.79-4 4v12c0 2.21 1.79 4 4 4h1v-12c0-.72.15-1.39.42-2m17.58 4h-1v-4h1c.55 0 1-.45 1-1s-.45-1-1-1H10c-2.21 0-4 1.79-4 4v12c0 2.21 1.79 4 4 4h13c.55 0 1-.45 1-1v-12c0-.55-.45-1-1-1m-13-4h10v4H10a2 2 0 110-4",
  fillRule: "evenodd"
});

const SvgCoursesFilled = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCoursesFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/courses-filled.ef2bfc7e.svg";
export { ForwardRef as ReactComponent };